import React, { ReactElement } from 'react'
import useGetCertificateHook from '../../hooks/useGetCertificateHook'

function File(): ReactElement {
  const { fileUrl } = useGetCertificateHook()
  return (
    <div className="pt05">
      <iframe
        src={`/pdfjs/web/viewer.html?file=${fileUrl}#page=1`}
        className="pdfIframe mb35 hFullVhMd"
        id={fileUrl}
        title="PDF"
        data-testid="certificate"
      />
    </div>
  )
}

export default File
